import React, { useEffect, useState } from "react";
import banner from "assets/img/profile/banner.png";
import UserService from "services/user.service";
import { IoMdClose } from "react-icons/io";
import Avatar from "react-avatar";
import moment from "moment";

const EventsModal = ({
  profileData,
  isOpen,
  onClose,
  isActive,
  onToggle,
  profileRef,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div
        className="w-96 rounded-xl bg-navy-800 px-6 pb-6 shadow-lg"
        ref={profileRef}
      >
        <div className="flex justify-end py-3">
          <IoMdClose className="cursor-pointer text-2xl" onClick={onClose} />
        </div>
        <div
          className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
          style={{ backgroundImage: `url(${banner})` }}
        >
          <div className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] !border-navy-700 bg-pink-400">
            {profileData.profileImg ? (
              <img
                src={profileData.eventImg}
                alt="Profile"
                className="h-full w-full rounded-full"
              />
            ) : (
              <Avatar
                name={profileData.title}
                className="h-full w-full rounded-full"
              />
            )}
          </div>
        </div>

        {/* Name and position */}
        <div className="mt-16 flex flex-col items-center">
          <h4 className="text-xl font-bold text-white">
            {profileData.title ? profileData.title : "--"}
          </h4>
          <p className="text-base font-normal text-gray-600">
            {profileData.description ? profileData.description : "--"}
          </p>
        </div>

        <div className="mt-3 grid grid-cols-5">
          <p className="col-span-2 text-base font-normal text-gray-600">
            Address:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.address ? profileData.address : "--"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            City:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.city ? profileData.city : "--"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            State:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.state ? profileData.state : "--"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            Country:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.country ? profileData.country : "--"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            Start Date:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.startDate
              ? moment.utc(profileData.startDate).format("DD/MM/YYYY hh:mm A")
              : "--"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            End Date:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.endDate
              ? moment.utc(profileData.endDate).format("DD/MM/YYYY hh:mm A")
              : "--"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            Zip Code:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.zipCode ? profileData.zipCode : "--"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            Activated:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.isActive ? "Yes" : "No"}
          </p>
          <p className="col-span-2 text-base font-normal text-gray-600">
            Coordinates:
          </p>
          <p className="col-span-3 text-base font-normal text-white">
            {profileData.latitude && profileData.longitude
              ? profileData.latitude + ", " + profileData.longitude
              : "--"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventsModal;
